import isNil from './isNil';

const isEmpty = object => {
    if (isNil(object)) {
        return true;
    }

    return (
        !Object.getOwnPropertySymbols(object).length &&
        !Object.getOwnPropertyNames(object).length
    );
};

export default isEmpty;



// WEBPACK FOOTER //
// ./Private/Scripts/helpers/isEmpty.js